// Custom arrow navigation for vertical product layout (without thumbnails)
if (!customElements.get('product-gallery-arrows')) {
  customElements.define(
    'product-gallery-arrows',
    class ProductGalleryArrows extends HTMLElement {
      constructor() {
        super();
        this.mediaGallery = this.closest('media-gallery');
        if (!this.mediaGallery) return;

        this.mediaItems = this.mediaGallery.querySelectorAll('.product__media-item');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');
        this.currentCounter = this.querySelector('.slider-counter--current');
        this.totalCounter = this.querySelector('.slider-counter--total');

        if (!this.prevButton || !this.nextButton || this.mediaItems.length === 0) return;

        // Start with the second image (index 1)
        this.currentIndex = 1;

        // Remove is-active from all items
        this.mediaItems.forEach((item) => {
          item.classList.remove('is-active');
        });

        // Add is-active to second item (or first if only one exists)
        if (this.mediaItems[this.currentIndex]) {
          this.mediaItems[this.currentIndex].classList.add('is-active');
        } else if (this.mediaItems[0]) {
          this.currentIndex = 0;
          this.mediaItems[0].classList.add('is-active');
        }

        this.totalCounter.textContent = this.mediaItems.length;
        this.updateCounter();
        this.updateButtons();

        this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
        this.nextButton.addEventListener('click', this.onNextClick.bind(this));
      }

      onPrevClick(event) {
        event.preventDefault();
        if (this.currentIndex > 0) {
          this.currentIndex--;
          this.updateActiveMedia();
        }
      }

      onNextClick(event) {
        event.preventDefault();
        if (this.currentIndex < this.mediaItems.length - 1) {
          this.currentIndex++;
          this.updateActiveMedia();
        }
      }

      updateActiveMedia() {
        // Remove is-active from all items
        this.mediaItems.forEach((item) => {
          item.classList.remove('is-active');
        });

        // Add is-active to current item
        this.mediaItems[this.currentIndex].classList.add('is-active');

        // Update counter
        this.updateCounter();

        // Update button states
        this.updateButtons();
      }

      updateCounter() {
        if (this.currentCounter) {
          this.currentCounter.textContent = this.currentIndex + 1;
        }
      }

      updateButtons() {
        if (this.currentIndex === 0) {
          this.prevButton.setAttribute('disabled', 'disabled');
        } else {
          this.prevButton.removeAttribute('disabled');
        }

        if (this.currentIndex === this.mediaItems.length - 1) {
          this.nextButton.setAttribute('disabled', 'disabled');
        } else {
          this.nextButton.removeAttribute('disabled');
        }
      }
    }
  );
}
